document.addEventListener("DOMContentLoaded", () => {
    // Remove required attribute from all search inputs
    const searchInputs = document.querySelectorAll(".wp-block-search__input");
    searchInputs.forEach((searchInput) => {
        searchInput.removeAttribute("required");
    });
    
    initCollapsibleSearch();
});

function initCollapsibleSearch() {
    const searchBlocks = document.querySelectorAll(".wp-block-search.is-collapsible");
    if (!searchBlocks.length) {
        return;
    }

    // Search icon SVG for toggle button
    const searchIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"><path d="M18.1196 17.0374L13.6266 12.5491C14.7521 11.176 15.3689 9.45771 15.3689 7.68326C15.3689 3.44556 11.9212 0 7.68561 0C6.65017 0 5.64474 0.202588 4.69701 0.604001C3.78163 0.992658 2.96002 1.54564 2.25469 2.25095C1.54937 2.95625 0.994157 3.77784 0.605499 4.69326C0.204087 5.64017 0 6.64558 0 7.68186C0 11.9196 3.44767 15.3651 7.68326 15.3651C9.46002 15.3651 11.1761 14.7484 12.5491 13.6229L17.0374 18.1113C17.1815 18.2553 17.3728 18.3349 17.5762 18.3349C17.7803 18.3349 17.9723 18.2561 18.1149 18.1113C18.415 17.8171 18.415 17.3347 18.1187 17.0383L18.1196 17.0374ZM13.8481 7.68096C13.8481 11.0798 11.0831 13.8426 7.68651 13.8426C4.28763 13.8426 1.52492 11.0775 1.52492 7.68096C1.52492 4.28342 4.28993 1.51937 7.68651 1.51937C11.084 1.51937 13.8481 4.28438 13.8481 7.68096Z" fill="currentColor"/></svg>';
    const closeIcon = searchIcon;

    // Initialize each search block
    searchBlocks.forEach((searchBlock) => {
        let toggleButton = null;
        let isInitialized = false;

        function createToggleButton() {
            if (toggleButton) {
                return toggleButton;
            }

            toggleButton = document.createElement("button");
            toggleButton.type = "button";
            toggleButton.className = "wp-block-search__toggle";
            toggleButton.setAttribute("aria-label", "Toggle search");
            toggleButton.setAttribute("aria-expanded", "false");
            toggleButton.innerHTML = searchIcon;

            // Insert toggle button before the search form
            const searchForm = searchBlock.querySelector(".wp-block-search__button");

            if (searchForm && searchForm.parentNode) {
                searchForm.parentNode.insertBefore(toggleButton, searchForm);
            } else {
                searchBlock.appendChild(toggleButton);
            }

            toggleButton.addEventListener("click", handleToggleClick);
            return toggleButton;
        }

        if (!isInitialized) {
            // Initialize collapsed state
            createToggleButton();
            searchBlock.classList.add("is-collapsible");
            collapseSearch();
            isInitialized = true;
        }

        function handleToggleClick(e) {
            e.preventDefault();
            e.stopPropagation();

            const isExpanded = searchBlock.classList.contains("is-expanded");

            if (isExpanded) {
                collapseSearch();
            } else {
                expandSearch();
            }
        }

        function expandSearch() {
            searchBlock.classList.add("is-expanded");

            // Toggle class on site-header to reflect expanded state
            const siteHeader = document.querySelector(".site-header");
            if (siteHeader) {
                siteHeader.classList.add("search-expanded");
            }

            if (toggleButton) {
                toggleButton.setAttribute("aria-expanded", "true");
                toggleButton.innerHTML = closeIcon;
            }

            // Focus the search input - optimized for mobile keyboard activation
            const searchInput = searchBlock.querySelector(".wp-block-search__input");
            if (searchInput) {
                // Remove aria-hidden and ensure input is focusable
                // This prevents the accessibility warning about focusing aria-hidden elements
                searchInput.removeAttribute("aria-hidden");
                searchInput.removeAttribute("tabindex");
                
                // On mobile devices, focus must happen synchronously within the user interaction
                // to trigger the keyboard. Try immediate focus first.
                searchInput.focus();

                // If immediate focus didn't work (input might not be visible yet due to CSS transitions),
                // use a minimal delay. For mobile, we need to maintain the user interaction chain,
                // so we use a very short timeout and also try click() as a fallback.
                const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                
                if (document.activeElement !== searchInput) {
                    // Use minimal delay to allow CSS transitions, but keep it short for mobile
                    const delay = isMobile ? 50 : 100;
                    
                    setTimeout(() => {
                        // Ensure input is visible and in viewport
                        if (searchInput.scrollIntoView) {
                            searchInput.scrollIntoView({
                                behavior: "auto", // Use 'auto' instead of 'smooth' for faster execution
                                block: "nearest",
                            });
                        }
                        
                        // Ensure aria-hidden is still removed before focusing
                        searchInput.removeAttribute("aria-hidden");
                        searchInput.removeAttribute("tabindex");
                        
                        // Try focus again
                        searchInput.focus();
                        
                        // For mobile devices, also try click() as a fallback to trigger keyboard
                        if (isMobile && document.activeElement !== searchInput) {
                            searchInput.click();
                            searchInput.focus();
                        }
                    }, delay);
                }
            }
        }

        function collapseSearch() {
            searchBlock.classList.remove("is-expanded");

            // Toggle class on site-header to reflect collapsed state
            const siteHeader = document.querySelector(".site-header");
            if (siteHeader) {
                siteHeader.classList.remove("search-expanded");
            }

            if (toggleButton) {
                toggleButton.setAttribute("aria-expanded", "false");
                toggleButton.innerHTML = searchIcon;
            }

            // Make search input non-focusable when collapsed to prevent accessibility warnings
            // When aria-hidden is set, the element must not be focusable
            const searchInput = searchBlock.querySelector(".wp-block-search__input");
            if (searchInput) {
                // Set tabindex to -1 to prevent focus when collapsed
                // This works with aria-hidden to ensure the element is properly hidden from assistive tech
                searchInput.setAttribute("tabindex", "-1");
                // Blur if currently focused to prevent the accessibility warning
                if (document.activeElement === searchInput) {
                    searchInput.blur();
                }
            }
        }

        // Close search when clicking outside
        document.addEventListener("click", (e) => {
            if (
                isInitialized &&
                searchBlock.classList.contains("is-expanded") &&
                !searchBlock.contains(e.target) &&
                toggleButton !== e.target
            ) {
                collapseSearch();
            }
        });

        // Close search on Escape key
        document.addEventListener("keydown", (e) => {
            if (
                isInitialized &&
                searchBlock.classList.contains("is-expanded") &&
                e.key === "Escape"
            ) {
                collapseSearch();
            }
        });
    });
}